import { Component, computed, input, ViewEncapsulation } from '@angular/core';

type DividerColor = 'darkGrey' | 'lightGrey' | 'white' | 'primary';
type DividerType = 'horizontal' | 'vertical';

@Component({
	selector: 'ui-divider',
	imports: [],
	templateUrl: './divider.component.html',
	encapsulation: ViewEncapsulation.None,
})
export class DividerComponent {
	type = input<DividerType>('horizontal');
	color = input<DividerColor>('lightGrey');
	noMargin = input<boolean>(false);

	private colorMap: Record<DividerColor, string> = {
		darkGrey: 'bg-secondary-800',
		lightGrey: 'bg-secondary-300',
		white: 'bg-white',
		primary: 'color-primary-700',
	};

	classes = computed(() => {
		let str = '';
		if (this.noMargin()) {
			str += 'm-0 ';
		} else {
			str += 'my-3';
		}
		switch (this.type()) {
			case 'horizontal':
				str += 'w-full h-px ';
				break;
			case 'vertical':
				str += 'w-px h-full ';
				break;
		}
		str += this.colorMap[this.color()];
		return str;
	});
}
